import axios from 'axios'

export default axios.create({
    baseURL: '',
    timeout: 10000
})



// WEBPACK FOOTER //
// ./src/api/index.js